import { Service } from '@/api/http-service';
import type {
  CompleteReviewDto,
  Review,
  ReviewCompletionScreenDto,
} from '@/entities/reviews/review.entity';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type { ReviewsControllerFindAllData } from '@carvia/ros-client-types';

export type FindAllReviewsQueryDto = NonNullable<ReviewsControllerFindAllData['query']>;

class ReviewsService extends Service {
  constructor() {
    super('/reviews');
  }

  async getReview(id: string, secretCompletionToken: string): Promise<ReviewCompletionScreenDto> {
    const res = await this.httpClient.get<ReviewCompletionScreenDto>(
      `${this.endpoint}/${id}/completion-screen`,
      {
        params: { secretCompletionToken },
      },
    );
    return res.data;
  }

  async complete(
    id: string,
    secretCompletionToken: string,
    review: CompleteReviewDto,
  ): Promise<void> {
    await this.httpClient.post(`${this.endpoint}/${id}/complete`, review, {
      params: { secretCompletionToken },
    });
  }

  async getReviews(params: FindAllReviewsQueryDto): Promise<PaginatedResponse<Review>> {
    const res = await this.httpClient.get<PaginatedResponse<Review>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }
}

export const reviewService = new ReviewsService();
